<template>
  <StandardDialogFullScreen opacity="1">
    <template #dialog>
      <router-view style="z-index: 20"/>
    </template>
    <template #header-workpackages v-if="work_package">
      <StandardFlexBox
        v-if="!create && (prefix_two_wp !== 's' && prefix_two_wp !== 'wag')"
        direction="column"
        class="font-weight-light white--text"
      >
        <TText 
          value="Creator{colon} {firstName} {lastName} - {email}" 
          :value_props="{
            colon: ':',
            firstName: work_package.owner.first_name,
            lastName: work_package.owner.last_name,
            email: work_package.owner.email,
          }"
          font_weight="400"
        />
        <TText 
          value="Updated{colon} {timestamp}"
          :value_props="{
            colon: ':',
            timestamp: work_package.updated.substring(0, 16),
          }"
          font_weight="400"
        />
      </StandardFlexBox>
      <StandardFlexBox
        class="font-weight-light ml-6"
        width="calc(100vw - 450px)"
        v-if="prefix_two_wp !== 's'"
        >
        <StandardDataField
          v-for="(hashtag, index) in work_package.hashtags"
          :key="index"
          class="user-select-none ml-1"
          :color="$vuetify.theme.isDark ? 'grey darken-3' : 'grey lighten-3'"
          :text_color="$vuetify.theme.isDark ? 'white' : 'black'"
          one_liner="true"
          readonly="true"
          :value="hashtag.tag"
          width="24%"
          >
          <template #prepend-slot>
            <div class="user-select-none">#</div>
          </template>
          <template #append-slot>
            <StandardDeleteButton
              v-if="!read_only"
              :zoom="1"
              @clickDelete="
              create?
              deleteWBLObject({
                path: [
                  {workpackage: ''},
                  {hashtags: ''}
                ],
                index: index
                }):removeHashtag(index)"/>
          </template>
        </StandardDataField>
        <StandardDataField
          v-if="!read_only"
          class="ml-1"
          :key="`addhashtag_${update_key_add_hashtag}`"
          :color="$vuetify.theme.isDark ? 'grey darken-3' : 'grey lighten-3'"
          :text_color="$vuetify.theme.isDark ? 'white' : 'black'"
          one_liner="true"
          @changeValue="
          create?
          createWBLObject({
            path: [
              {workpackage: ''},
              {hashtags: ''}
            ],
            wbl_object: {
              tag: $event.replace(/\s/g,'')
            }
          })
          :
          addHashtag($event),
          update_key_add_hashtag++
          "
        >
        <template #prepend-slot>
          <div class="user-select-none">#</div>
        </template>
        </StandardDataField>
      </StandardFlexBox>
    </template>
    <template #header-close>
      <template v-if="!create && prefix_two_wp !== 's'">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
        <v-btn icon
          @click="$router.push({
            name: nav_back?nav_back:'WorkBenchWorkPackages'
            })"
            v-on="on"
            v-bind="attrs"
            color="green"
          >
              <v-icon>done</v-icon>
        </v-btn>
      </template>
      <span>{{$t('WorkBench.Editor.Workpackage.Toolbar.done')}}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-if="!read_only && $route.params.template_type === 'custom'"
            v-on="on"
            v-bind="attrs"
            @click="createWBObject({
              url: [
                {[`${prefix}${prefix_two_wp}workpackages`]: work_package_id},
                {copyOwnWorkpackage: ''}
              ],
              url_suffix: '?show=showWithEntitiesNormalized'
              }).then(() => {
                $router.push({
                  name: 'WorkBenchWorkPackages'
                })
              })"
            >
            <v-icon>content_copy</v-icon>
          </v-btn>
        </template>
        <span>{{$t('WorkBench.Editor.Workpackage.Toolbar.copy')}}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-if="!read_only && $route.params.template_type === 'custom'"
            v-on="on"
            v-bind="attrs"
            @click="createWBObject({
              url: [
                {[`${prefix}${prefix_two_wp}workpackages`]: work_package_id},
                {copyOwnWorkpackageWithoutSteps: ''}
              ],
              url_suffix: '?show=showWithEntitiesNormalized'
              }).then(() => {
                $router.push({
                  name: 'WorkBenchWorkPackages'
                })
              })"
            >
            <v-icon>file_copy</v-icon>
          </v-btn>
        </template>
        <span>{{$t('WorkBench.Editor.Workpackage.Toolbar.copyWithoutSteps')}}</span>
      </v-tooltip>
        <!-- upload to community -->
        <TUploadButton
          v-if="work_package && !read_only"
          icon="people"
          :value="work_package.is_community_suggested"
          :tooltip="$t('WorkBench.Editor.Workpackage.Toolbar.uploadToCommunity')"
          @upload="updateWBObject({
            url: [
              {[`${prefix}${prefix_two_wp}workpackages`]: work_package_id},
            ],
            update: {
              is_community_suggested: true
            }
          })"
        />
        <!-- community download -->
        <template v-if="work_package && work_package.template_type === 'community'">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              :color="work_package.likes.some(like => like.user.id === getUserId)?'blue':'grey'"
              v-on="on"
              v-bind="attrs"
              @click="
              createWBObject({
                url: [
                  {workpackages: '0/copyfromcommunity'},
                  {showWithEntitiesNormalized: ''},
                ],
                wb_object: {
                  cwork_package: work_package.id
                }
              }).then(() => {
                work_package.likes.some(like => like.user.id === getUserId)?
                '':
                updateWBObject({
                  url: [
                  {cworkpackages: work_package.id},
                  {like: ''},
                  ],
                  update: {
                    likes: getLikes(work_package.likes)
                  }
                })
              })"
              >
              <v-icon class="mr-5">download</v-icon>
              {{work_package.likes.length}}
            </v-btn>
            </template>
            <span>{{$t('WorkBench.Editor.Workpackage.Toolbar.download')}}</span>
          </v-tooltip>
        </template>
        <!-- company download -->
        <template v-if="$route.params.template_type === 'company'">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                :color="work_package.likes.some(like => like.user.id === getUserId)?'blue':'grey'"
                v-on="on"
                v-bind="attrs"
                @click="
                createWBObject({
                  url: [
                    {workpackages: '0/copyfrombusiness'},
                    {showWithEntitiesNormalized: ''},
                  ],
                  wb_object: {
                    bwork_package: work_package.id
                  }
                }).then(() => {
                  work_package.likes.some(like => like.user.id === getUserId)?
                  '':
                  updateWBObject({
                    url: [
                    {bworkpackages: work_package.id},
                    {like: ''},
                    ],
                    update: {
                      likes: getLikes(work_package.likes)
                    }
                  })
                })"
                >
                <v-icon class="mr-5">download</v-icon>
                {{work_package.likes.length}}
              </v-btn>
            </template>
            <span>{{$t('WorkBench.Editor.Workpackage.Toolbar.download')}}</span>
          </v-tooltip>
        </template>
        <!-- upload to company -->
        <template v-if="!read_only && hasPermission('Business READ') && $route.params.template_type === 'custom'">
          <TUploadButton
            v-if="work_package && !read_only && !create"
            icon="work"
            :counter="getWBObjectsFiltered({type: 'bworkpackages',
              filter: {
                color: work_package.color,
                token: work_package.token,
                name: work_package.name,
                owner: work_package.owner
              }
            }).length"
            :tooltip="$t('WorkBench.Editor.Workpackage.Toolbar.uploadToCompany')"
            @upload="createWBObject({
              template_type: 'company',
                url: [
                  {bworkpackages: 'createfromworkpackage'},
                  {showWithEntitiesNormalized: ''}
                ],
                wb_object: {
                  work_package_id: work_package.id
                }
              })"
          />
        </template>
        <!-- delete workpackage -->
        <StandardDeleteBtn
          v-if="
            work_package && !read_only && prefix === '' && prefix_two_step.substring(0,1) == 'w'
            "
          :el="work_package"
          :tooltip="$t('WorkBench.Editor.Workpackage.Toolbar.delete')"
          @deleteClick="deleteWBObject({
                url: [
                  {[`workpackages`]: work_package.id}
                ]
              }),
              $router.push({
                name: `${location}WorkPackages`
                })"

          />
        <StandardDeleteBtn
          v-else-if="
            !read_only ||
            (work_package.template_type === 'company' && hasPermission('BWorkPackage DELETE')) ||
            (work_package.template_type === 'community' && hasPermission('CWWorkPackage DELETE'))
            "
          :el="work_package"
          :tooltip="$t('WorkBench.Editor.Workpackage.Toolbar.delete')"
          @deleteClick="deleteWBObject({
                url: [
                  {[`${prefix}${prefix_two_wp}workpackages`]: work_package.id}
                ]
              }),
              $router.push({
                name: `${location}WorkPackages`
                })"

          />
      </template>
      <template v-else-if="!create">
        <v-btn icon
          @click="$router.push({
            name: nav_back?nav_back:'WorkBenchWorkPackages'
            })"
          >
          <v-icon color="green">done</v-icon>
        </v-btn>
      </template>
      <template v-else>
        <v-btn
          color="orange"
          @click="
          resetWorkpackage()"
          >
          <v-icon
            >
          restart_alt
        </v-icon>
          Reset
        </v-btn>
        <v-spacer/>
        <v-btn
          class="ml-2"
          color="green"
          @click="createWP()"
          >
          <v-icon
            >
          add
        </v-icon>
          Create
        </v-btn>

        <RadialCheckbox v-if="create_for_project" :is_checked="save_to_workbench" @setActive="save_to_workbench = !save_to_workbench" />
        <TText v-if="create_for_project" value="Save to WORK.bench" style="margin-left: 8px;"/>

        <v-btn
          depressed
          class="ml-2"
          color="grey darken-4"
          @click="$router.push({
            name: nav_back?nav_back:'WorkBenchWorkPackages'
            })"
          >
          <v-icon
            >
          close
        </v-icon>
          Cancel
        </v-btn>
      </template>
    </template>
    <template #content>
      <!-- statistics -->
      <StandardFlexBox
        class="overflow-visible"
        :height="bottom_bar.show?'30px':'300px'"
        style="position: relative"
        >
        <!-- attributes -->
        <StandardFlexBox
          v-if="work_package"
          class="mr-1"
          width="calc(100% / 3)"
          height="100%"
          justify_content="space-around"
          align_items="flex-end"
          :no_wrap="true"
          @click.native="bottom_bar.show = false, focus_page = 'attributes'"
          :style="focus_page !== 'attributes'?'filter: brightness(0.6); transition: filter 0.2s ease-in-out; cursor: pointer':''"
          >
          <StatisticsBeam
            v-for="value in [
            'time_effort_planned',
            'manpower_planned',
            'quantity_value'
            ]"
            :key="value"
            :value="work_package[value]"
            :color="work_package.color"
            :text_color="work_package.textcolor"
            :max_value="wpr[value] > work_package[value]?wpr[value]:work_package[value]"
            width="30px"
            :no_zoom="true"
            >
            <WorkBenchWorkPackageAverageLine
            :value="ai_animation?0:wpr[value]"
            :max_value="wpr[value] > work_package[value]?wpr[value]:work_package[value]"
            >
              <AIIcon
                width="18px"
                :animation="ai_animation"
                />
            </WorkBenchWorkPackageAverageLine>
          </StatisticsBeam>
        </StandardFlexBox>
        <!-- steps -->
        <StandardFlexBox
          v-for="(type, index) in step_types"
          :key="`${type}${index}`"
          :width="selected_step_type === type?'calc(100% / 3 - 250px - 8px)':'50px'"
          height="100%"
          justify_content="space-around"
          align_items="flex-end"
          :no_wrap="true"
          @click.native="bottom_bar.show = false, focus_page = 'steps'"
          :style="focus_page !== 'steps' || selected_step_type !== type?'filter: brightness(0.6); transition: filter 0.2s ease-in-out; cursor: pointer':''"
          >
          <StatisticsBeam
            v-if="work_package"
            :value="work_package[type].length"
            :color="work_package.color"
            :text_color="work_package.textcolor"
            :max_value="wpr[`${type}_counts`] > work_package[type].length?wpr[`${type}_counts`]:work_package[type].length"
            :width="selected_step_type === type?'30px':'15px'"
            :no_zoom="true"
            >
            <WorkBenchWorkPackageAverageLine
            :value="ai_animation?0:wpr[`${type}_counts`]"
            :max_value="wpr[`${type}_counts`] > work_package[type].length?wpr[`${type}_counts`]:work_package[type].length"
            :width="selected_step_type === type?'35px':'16px'"
            >
            <AIIcon
              :width="selected_step_type === type?'18px':'10px'"
              :animation="ai_animation"
              />
          </WorkBenchWorkPackageAverageLine>
        </StatisticsBeam>
        </StandardFlexBox>
      </StandardFlexBox>
      <!-- Workpackage Pages -->
      <StandardFlexBox
        height="calc(100% - 300px)"
        >
        <!-- Attributes -->
      <StandardFlexBox
        v-if="work_package"
        class="pl-1 pr-1 pt-1 pb-1"
        height="100%"
        width="calc(100% / 3)"
        @click.native="bottom_bar.show = false, focus_page = 'attributes'"
        >
        <!-- @mousedown.native="bottom_bar.show = true, bottom_bar.content = 'attributes'" -->
        <WorkBenchWorkPackage
          :color="work_package.color"
          :text_color="work_package.textcolor"
          :style="focus_page !== 'attributes'?'filter: brightness(0.6); transition: filter 0.2s ease-in-out; cursor: pointer':''"
          >
          <template #header>
            <WorkBenchWorkPackageHeader
              :icon="work_package.icon"
              :token="work_package.token"
              :name="work_package.name"
              :color="work_package.color"
              :text_color="work_package.textcolor"
              :no_color_picker="read_only"
              @clickColorPicker="read_only?'':bottom_bar.show = true, bottom_bar.content = 'color', focus_page = 'attributes'"
              @clickIcon="read_only?'':bottom_bar.show = true, bottom_bar.content = 'icon', focus_page = 'attributes'"
              >
              <template #text>
                <StandardDataField
                  placeholder="token"
                  width="40px"
                  :text_color="work_package.textcolor"
                  :maxlength="3"
                  :value="work_package.token"
                  :readonly="read_only"
                  @changeValue="genericUpdate({
                    token: $event.toUpperCase()
                  })"
                />
                <div class="ml-2 mr-2">-</div>
                <StandardDataField
                  :maxlength="100"
                  placeholder="name"
                  width="calc(100vw / 3 - 140px)"
                  :text_color="work_package.textcolor"
                  :value="work_package.name"
                  :readonly="read_only"
                  @changeValue="genericUpdate({
                    name: $event
                  })"
                />
              </template>
            </WorkBenchWorkPackageHeader>
          </template>
          <template #content>
            <div style="display: flex; width: 100%;">
              <div style="display: flex; flex-direction: column; gap: 5px; width: 100%;">
                <StandardDataField
                placeholder="external id"
                width="100%"
                flat="true"
                header="external id"
                :text_color="work_package.textcolor"
                :value="work_package.external_id"
                :readonly="read_only"
                @changeValue="genericUpdate({
                  external_id: $event
                })"
              />
              <v-divider :color="work_package.textcolor" width="100%"/>
              <StandardDataField
                :maxlength="500"
                placeholder="description"
                width="100%"
                header="description"
                flat="true"
                :resizable="true"
                :text_color="work_package.textcolor"
                :value="work_package.description"
                :readonly="read_only"
                @changeValue="genericUpdate({
                  description: $event
                })"
              />
              </div>
            </div>
            
            <v-divider :color="work_package.textcolor" width="100%"/>
            <StandardFlexBox>
            <!-- attributes planned -->
            <StandardFlexBox
              class="pa-1"
              width="100%"
              direction="column"
              >
              attributes planned
              <StandardFlexBox v-if="work_package">
                <StandardDataField
                :value="work_package.time_effort_planned"
                :readonly="read_only"
                icon="speed"
                width="28%"
                :text_color="work_package.textcolor"
                :type="'number'"
                @changeValue="genericUpdate({
                  time_effort_planned: parseFloat(parseFloat($event).toFixed(2))
                })"
                />
                <div style="width: 8%; line-height: 33px; text-align: center;">/</div>
                <StandardDataField
                  :value="work_package.manpower_planned"
                  :readonly="read_only"
                  icon="accessibility"
                  width="28%"
                  :text_color="work_package.textcolor"
                  :type="'number'"
                  @changeValue="genericUpdate({
                    manpower_planned: parseFloat(parseFloat($event).toFixed(2))
                  })"
                  />
                <div style="width: 8%; line-height: 33px; text-align: center;">=</div>
                <StandardDataField
                  :value="work_package.manpower_planned === 0 || isNaN(Math.round((work_package.time_effort_planned/work_package.manpower_planned)*100) / 100)?
                          '':Math.round((work_package.time_effort_planned/work_package.manpower_planned)*100) / 100"
                  icon="timer"
                  width="28%"
                  :text_color="work_package.textcolor"
                  :readonly="true"
                  />
              </StandardFlexBox>
              <StandardFlexBox>
                <StandardDataField
                  :value="work_package.quantity_value"
                  :readonly="read_only"
                  icon="drag_indicator"
                  width="33%"
                  :text_color="work_package.textcolor"
                  :type="'number'"
                  @changeValue="genericUpdate({
                    quantity_value: parseInt($event)
                  })"
                  />
                <StandardDataField
                  :value="work_package.quantity_unit"
                  :readonly="read_only"
                  icon="drag_indicator"
                  width="33%"
                  :text_color="work_package.textcolor"
                  @changeValue="genericUpdate({
                    quantity_unit: $event
                  })"
                  />
              </StandardFlexBox>
            </StandardFlexBox>
            </StandardFlexBox>
          </template>
        </WorkBenchWorkPackage>
      </StandardFlexBox>
      <!-- Steps -->
      <StandardFlexBox
        v-if="work_package"
        class="pl-1 pr-1 pt-1 pb-1 overflow-hidden"
        height="100%"
        width="calc(100% / 3)"
        no_wrap="true"
        @click.native="focus_page = 'steps'"
        >
        <WorkBenchWorkPackage
          :tabs="true"
          :color="work_package.color"
          :text_color="work_package.textcolor"
          :style="focus_page !== 'steps'?'filter: brightness(0.6); transition: filter 0.2s ease-in-out; cursor: pointer':''"
          >
          <template #header>
            <WorkBenchWorkPackageTab
              v-for="(type, index) in step_types"
              :key="type"
              :tab="{
                icon: ['truck-container', 'crossed-pencil-ruler', 'person-helmet', 'speech-bubble-check', 'fragile', 'handshake', 'wall-brick', 'crane'][index],
                text: `${selected_step_type.substring(`${prefix_one_step}${prefix_two_step}`.length, selected_step_type.length-5).toUpperCase()}.steps`,
                type: `${type.substring(`${prefix_one_step}${prefix_two_step}`.length, type.length-5).toUpperCase()}.steps`
                }"
              :width="selected_step_type === type?'calc(100% - 250px)':'50px'"
              :selected="selected_step_type === type?true:false"
              :color="work_package.color"
              :text_color="work_package.textcolor"
              :disabled="!checkStepPermission(type)"
              @mousedown.native.prevent.stop="switchStepTab(type)"
              />
          </template>
          <template #content v-if="work_package">
            <StandardFlexBox
              ref="step_flex_box"
              width="100%"
              height="calc(100% - 25px)"
              >
            <draggable
              v-if="work_package[selected_step_type].length !== 0"
              :key="`draggable_${selected_step_type}`"
              animation="300"
              style="width: 100%"
              forceFallback="true"
              fallbackOnBody="true"
              :disabled="!read_only && draggable_steps?false:true"
              :value="work_package[selected_step_type]"
              @input="
                create || create_sequence?
                updateWBLObject({
                  path: create_sequence?
                  [
                    {sequence: ''},
                    {swaggons: waggon_id},
                    {sworkpackages: work_package_id}
                  ]
                  :
                  [
                    {workpackage: ''},
                  ],
                  update: {
                    [selected_step_type]: $event
                  },
                })
                :
                ''
                "
              @end="
              create || create_sequence?
              ''
              :
              changeWBObjectPosition({
                url: sequence_id?
                [
                  {[`${prefix}sequences`]: sequence_id},
                  {[`${prefix}swaggons`]: waggon_id},
                  {[`${prefix}${prefix_two_wp}workpackages`]: work_package_id},
                  {[selected_step_type]: work_package[selected_step_type][$event.oldIndex]},
                  {pushpositions: ''}
                ]
                :
                [
                  {[`${prefix}${prefix_two_wp}workpackages`]: work_package_id},
                  {[selected_step_type]: work_package[selected_step_type][$event.oldIndex]},
                  {pushpositions: ''}
                ],
                target: {
                  target_id: work_package[selected_step_type][$event.newIndex],
                }
                })"
            >
              <StandardStep
                v-for="(step, index) in (create || create_sequence?work_package[selected_step_type]:getWBObjects({type: selected_step_type, ids: work_package[selected_step_type]}))"
                :key="selected_step_type + create || create_sequence?index:step.id"
                :location="selected_step_type.includes('worksteps') || selected_step_type.includes('machinesteps') ? 'taktplan_edit' : ''"
                :step="step"
                :step_type="selected_step_type.includes('worksteps')?'worksteps':(selected_step_type.includes('machinesteps')?'machinesteps':'othersteps')"
                :new_step_type="selected_step_type.substring(`${prefix}${prefix_two_wp}`.length, selected_step_type.length-5)"
                :drag_handle="!read_only"
                :text_color="work_package.textcolor"
                :color="work_package.color"
                :readonly="read_only"
                @enableDragging="draggable_steps = true"
                @disableDragging="draggable_steps = false"
                @click.native.prevent.stop="
                  read_only?'':
                  (step_text = step.text,
                  add_step = false,
                  edit_step = true,
                  create || create_sequence?
                  (edit_index = index)
                  :
                  (edit_id = step.id)
                  ,
                  bottom_bar.show = true,
                  bottom_bar.content = selected_step_type,
                  focus_page = 'steps',
                  $event.target.focus())
                  "
                @inputStepValue="step_text = $event.target.value"
                @changeStepValue="genericUpdateStep(selected_step_type, index, $event, step)"
                @changePerformanceValue="genericUpdateStep(selected_step_type, index, { text: step.text, performance_value: parseFloat($event) }, step)"
                @changeMassRelation="genericUpdateStep(selected_step_type, index, { text: step.text, mass_relation: $event.value }, step)"
                @deleteStep="genericDeleteStep(selected_step_type, index, step)"
              />
            </draggable>
            <StandardStepAdd
              v-if="!read_only && (!bottom_bar.show || bottom_bar.content !== selected_step_type || edit_step === true)"
              width="100%"
              style="position: sticky; bottom: 4px"
              :text="`add ${selected_step_type.substring(`${prefix}${prefix_two_wp}`.length, selected_step_type.length-5).toUpperCase()}.step`"
              @click.native="
                step_text = ''
                add_step = true,
                edit_step = false,
                bottom_bar.show = true,
                bottom_bar.content = selected_step_type,
                $event.target.focus(),
                stepFlexBoxScrollBottom()
                "
              />
            <StandardStep
              v-else-if="!read_only"
              width="100%"
              style="position: sticky; bottom: 0px"
              :key="update_key_add_step"
              :step="{text: step_text, done: false}"
              :step_type="selected_step_type.includes('worksteps')?'worksteps':(selected_step_type.includes('machinesteps')?'machinesteps':'othersteps')"
              :new_step_type="selected_step_type.substring(`${prefix}${prefix_two_wp}`.length, selected_step_type.length-5)"
              :add_step="true"
              :color="work_package.color"
              :text_color="work_package.textcolor"
              ref="add_step"
              clearable="true"
              @deleteStep="!edit_step_templates && bottom_bar.show?$refs.add_step.$refs['standard-step-input-text'].focus():''"
              @inputStepValue="step_text = $event.target.value"
              @changeStepValue="genericCreateStep(selected_step_type, $event)"
            />
            </StandardFlexBox>
          </template>
        </WorkBenchWorkPackage>
      </StandardFlexBox>
      <!-- More  -->
      <StandardFlexBox
        class="pl-1 pr-1 pt-1 pb-1 overflow-hidden"
        height="100%"
        width="calc(100%/3)"
        no_wrap="true"
        @click.native="bottom_bar.show = false, focus_page = 'more'"
        v-if="work_package"
        >
        <!-- v-for="selected_more_type in ['costs', 'logistics', 'sustainability']"
        :key="selected_more_type"
        :margin="`0px ${selected_more_type === type?'-55px':'calc(-100% + 30px)'} 0px 0px`"
        @click.native="selected_more_type = type" -->
        <WorkBenchWorkPackage
          :tabs="true"
          :color="work_package.color"
          :text_color="work_package.textcolor"
          :style="focus_page !== 'more'?'filter: brightness(0.6); transition: filter 0.2s ease-in-out; cursor: pointer':''"
          >
          <template #header>
            <WorkBenchWorkPackageTab
              v-for="(type, index) in ['costs', 'attachements']"
              :key="type"
              :tab="{
                icon: ['money', 'image'][index],
                text: selected_more_type.toUpperCase(),
                text: type.toUpperCase()
                }"
              :width="selected_more_type === type?'calc(100% - 50px)':'50px'"
              :selected="selected_more_type === type?true:false"
              :color="work_package.color"
              :text_color="work_package.textcolor"
              @mousedown.native.prevent.stop="bottom_bar.content = type, selected_more_type = type, bottom_bar.show?add_step = true:''"
              />
          </template>
          <template #content>
            <template v-if="selected_more_type === 'costs'">
              <!-- Legende -->
              <StandardFlexBox width="100%" height="30px">
                <StandardDataField
                  width="20%"
                  flat="true"
                  :readonly="true"
                  />
                  <div class="ml-3 mr-2"/>
                <StandardDataField
                  width="20%"
                  value="Labour"
                  icon="accessibility"
                  :text_color="work_package.textcolor"
                  :readonly="true"
                  />
                <div class="ml-2 mr-2">+</div>
                <StandardDataField
                  width="20%"
                  value="Material"
                  icon="view_module"
                  :text_color="work_package.textcolor"
                  :readonly="true"
                  />
                <div class="ml-2 mr-2">=</div>
                <StandardDataField
                  width="20%"
                  value="     +"
                  icon="accessibility"
                  :text_color="work_package.textcolor"
                  append_icon="view_module"
                  :readonly="true"
                  />
              </StandardFlexBox>
              <StandardFlexBox width="100%">
                <StandardDataField
                  width="20%"
                  value="budget"
                  icon="account_balance_wallet"
                  :text_color="work_package.textcolor"
                  :readonly="true"
                  />
                  <div class="ml-3 mr-2"/>
                <StandardDataField
                  width="20%"
                  :text_color="work_package.textcolor"
                  :value="work_package.costs_budget_labour"
                  :readonly="read_only"
                  :type="'number'"
                  @changeValue="genericUpdate({
                    costs_budget_labour: parseInt($event)
                  })"
                  />
                  <div class="ml-2 mr-2">+</div>
                <StandardDataField
                    width="20%"
                    :text_color="work_package.textcolor"
                    :value="work_package.costs_budget_material"
                    :readonly="read_only"
                    :type="'number'"
                    @changeValue="genericUpdate({
                      costs_budget_material: parseInt($event)
                    })"
                    />
                  <div class="ml-2 mr-2">=</div>
                <StandardDataField
                  width="20%"
                  :text_color="work_package.textcolor"
                  :value="parseInt(work_package.costs_budget_labour) + parseInt(work_package.costs_budget_material)"
                  :readonly="true"
                  />
              </StandardFlexBox>
            </template>
            <template v-if="selected_more_type === 'attachements'">
              <StandardFlexBox
                ref="image_flex_box"
                direction="column"
                height="calc(100% - 33px)"
                :no_wrap="true"
                >
                <!-- v-for="image in [{
                  id: 1,
                  image: 'https://helpx.adobe.com/content/dam/help/en/stock/how-to/visual-reverse-image-search/jcr_content/main-pars/image/visual-reverse-image-search-v2_intro.jpg',
                  user: 'Philipp Basler',
                  created: '2011-11-11 10:10',
                  comment: 'blablas'
                }]" -->
                <!-- <template v-if="work_package[`${prefix}${prefix_two !== 'w'?prefix_two:''}workpackageimages`].length !== 0"> -->
                <template v-if="work_package[`${prefix}${prefix_two_wp}${prefix !== 'b' && prefix_two_wp === ''? 'w':''}workpackageimages`].length !== 0">
                  <StandardDataField
                    v-for="(image, index) in (create || create_sequence?work_package[`${prefix}${prefix_two_wp}${prefix !== 'b' && prefix_two_wp === ''? 'w':''}workpackageimages`]:getWBObjects({type: `${prefix}${prefix_two_wp}${prefix !== 'b' && prefix_two_wp === ''? 'w':''}workpackageimages`, ids: work_package[`${prefix}${prefix !== 'b' && prefix_two_wp === ''? 'w':''}workpackageimages`]}))"
                    :key="create || create_sequence?index:image.id"
                    :image="create || create_sequence?image.local_url:image.image"
                    :header="create || create_sequence?'':`${image.created.substring(0, 19)}`"
                    :value="image.comment"
                    :readonly="true"
                    :text_color="work_package.textcolor"
                    width="100%"
                    @clickImage="
                    /* create?
                    $router.push({
                      name: 'WorkBenchCreateWPWorkPackageImagesZoomImage',
                      params: {
                        image_id: image.id,
                        images: work_package[`${prefix}${prefix_two !== 'w'?prefix_two:''}workpackageimages`]
                      },
                    })
                    : */
                    $router.push({
                      name: `${location}WorkPackageEditorWorkPackagesImagesZoomImage`,
                      params: {
                        image_id: create || create_sequence?index:image.id,
                      },
                      })"
                    />
                  </template>
                  <!-- add image -->
                <StandardDataField
                  v-if="!read_only"
                  style="position: sticky; bottom: 5px"
                  :key="`add_image_${update_key_add_image}`"
                  line_height="30px"
                  :color="$vuetify.theme.isDark ? 'grey darken-3' : 'grey lighten-3'"
                  :text_color="$vuetify.theme.isDark ? 'white' : 'black'"
                  :header="new_image.name"
                  :value="new_image.comment"
                  append_icon="send"
                  placeholder="add comment"
                  width="100%"
                  @changeValue="new_image.comment = $event"
                  @clickAppendIcon="uploadImage()"
                  >
                  <template #prepend-slot>
                    <v-icon
                      v-if="!new_image.file"
                      class="ml-1 mr-1"
                      @click="$refs.addWorkpackageImage.click()"
                      >
                      add_a_photo
                    </v-icon>
                    <v-img
                      class="standard-data-image-preview"
                      v-else
                      :src="new_image.local_url"
                      height="34px"
                      width="47px"
                      contain
                      @click="$refs.addWorkpackageImage.click()"
                      />
                    <input
                      v-show="false"
                      ref="addWorkpackageImage"
                      type="file"
                      @change="selectWorkpackageImage($refs.addWorkpackageImage.files[0])"
                      >
                  </template>
                </StandardDataField>
              </StandardFlexBox>
            </template>
          </template>
        </WorkBenchWorkPackage>
      </StandardFlexBox>
    </StandardFlexBox>
    <!-- Bottom Bar -->
    <StandardFlexBox
      class="pl-1 pr-1"
      height="calc(100% - (100% - 270px))"
      style="position: relative; overflow: visible"
      >
      <Activator
        v-if="bottom_bar.show"
        class="self-centered cursor-s-resize"
        style="left: 50%"
        @mousedown.native="bottom_bar.show = false"
        />
      <!-- AI Recommendations -->
      <StandardFlexBox
        v-if="bottom_bar.content.substring(bottom_bar.content.length-5, bottom_bar.content.length) === 'steps'"
        class="pa-1 pr-2 mr-2 grey darken-4 t-rounded t-shadow"
        width="calc(100% / 3 - 4px)"
        height="100%"
        >
        <template v-if="!ai_animation_suggestion">
          <StandardFlexBox
            direction="column"
            width="100%"
            >
          <StandardFlexBox
          >
          <AIIcon
          class="mr-1"
          style="margin-top: 2px"
          width="18px"
          />
          <div class="font-weight-light">
            <TText value="Recommendations"/>
          </div>
        </StandardFlexBox>
        <template v-if="work_package.token !== ''">
          <StandardStep
            v-for="(step_text, index) in wpr[selected_step_type]"
            :key="index"
            :step="{text: step_text, done: false}"
            :step_type="bottom_bar.content.includes('worksteps')?'worksteps':'othersteps'"
            :new_step_type="selected_step_type.substring(`${prefix}${prefix_two_wp}`.length, selected_step_type.length-5)"
            cursor="pointer"
            readonly="true"
            text_color="white"
            width="100%"
            @click.native="handleRecommendationsClick(selected_step_type, step_text)"
          />
        </template>
        <div v-else class="font-weight-light ml-1 mt-1"><TText value="Please set a Token"/></div>
        </StandardFlexBox>
        </template>
        <AIIcon
        v-else
        style="margin-left: calc(50% - 100px); margin-top: 30px"
        width="200px"
        :animation="true"
        />
      </StandardFlexBox>
      <div
        class="pa-1 grey darken-4 t-rounded t-shadow"
        :style="`
          width: ${bottom_bar.content.substring(bottom_bar.content.length-5, bottom_bar.content.length) === 'steps'
            ? 'calc(100% * 2 / 3 - 6px)'
            : '100%'};
          height: 100%;
          flex-direction: column;
        `"
      >
        <!-- Steps -->
        <template v-if="bottom_bar.content.substring(bottom_bar.content.length-5, bottom_bar.content.length) === 'steps'">
         <StandardFlexBox height="30px" width="100%" justify_content="space-between" style="overflow: hidden">
            <div
              class="font-weight-light white--text"
              >
              {{bottom_bar.content.substring(`${prefix}${prefix_two_wp}`.length, bottom_bar.content.length-5).toUpperCase()}}.step templates
            </div>
            <v-btn
              icon
              small
              @mousedown.native.prevent.stop="edit_step_templates = !edit_step_templates">
              <v-icon small>{{edit_step_templates?'done':'edit'}}</v-icon>
            </v-btn>
          </StandardFlexBox>
          <StandardFlexBox height="calc(100% - 30px)">
            <StandardStep
              v-for="step in getWBObjects({type: bottom_bar.content.substring(`${prefix}${prefix_two_wp}`.length)}).filter(step => step.text.toLowerCase().includes(step_text.toLowerCase()))"
              :step="step"
              :key="step.id"
              :step_type="bottom_bar.content.includes('worksteps')?'worksteps':'othersteps'"
              :new_step_type="selected_step_type.substring(`${prefix}${prefix_two_wp}`.length, selected_step_type.length-5)"
              :readonly="!edit_step_templates"
              text_color="white"
              width="50%"
              :cursor="!edit_step_templates?'pointer':''"
              @mousedown.native.prevent.stop="
                (
                  ( !edit_step_templates && !edit_step )
                  ?
                    genericCreateStep(selected_step_type, step)
                  : ''
                  ( !edit_step_templates && edit_step )
                  ?
                    genericUpdateStep(selected_step_type, edit_index, step, {id: edit_id})
                  : ''
                ),
                edit_step_templates ? $event.target.focus() : ''
                "
              @changeStepValue="
                edit_step_templates?
                updateWBObject({
                url: [
                  {[bottom_bar.content.substring(`${prefix}${prefix_two_wp}`.length)]: step.id}
                ],
                update: $event,
              }):''"
              @deleteStep="deleteWBObject({
                url: [
                  {[bottom_bar.content.substring(`${prefix}${prefix_two_wp}`.length)]: step.id}
                ]
              })"
            />
          </StandardFlexBox>
        </template>

        <!-- Colors -->
        <template v-if="bottom_bar.content === 'color'">
          <StandardFlexBox height="30px" width="100%">
            <TText value="COLORS" />
            <template v-if="selectedColorIsFavorite">
              <TTooltip value="remove from favorite">
                <v-btn class="mr-2" icon @click="remove_favorite_colors(work_package.color)">
                  <TIcon name="star-filled"/>
                </v-btn>
              </TTooltip>
            </template>
            <template v-else>
              <TTooltip value="add to favorite">
                <v-btn class="mr-2" icon @click="add_favorite_colors(work_package.color)" >
                  <TIcon name="star"/>
                </v-btn>
              </TTooltip>
            </template>
          </StandardFlexBox>
          <template v-if="favorite_user_colors.length > 0">  
            <div class="d-flex mt-3 align-center" style="width: 100%;">
              <WorkBenchWorkPackageColorPicker
                class="ml-2"
                v-for="color in favorite_user_colors"
                :key="color.color"
                :color="color.color.split(' ')[0]"
                :selected_color="work_package.color"
                :favorite_mode = "true"
                :favorite_color = color.color
                @clickColor="genericUpdate({
                  color: $event.color,
                  textcolor: $event.text_color
                })"
                />
            </div>
          <v-divider class="mt-3 mb-3"></v-divider>
          </template>
           <StandardFlexBox height="calc(100% - 30px)">
            <WorkBenchWorkPackageColorPicker
              class="ml-2"
              v-for="color in [
                'red',
                'pink',
                'purple',
                'deep-purple',
                'indigo',
                'blue',
                'light-blue',
                'cyan',
                'teal',
                'green',
                'light-green',
                'lime',
                'yellow',
                'amber',
                'orange',
                'deep-orange',
                'brown',
                'blue-grey',
                'grey'
              ]"
              :key="color"
              :color="color"
              :selected_color="work_package.color"
              @clickColor="genericUpdate({
                color: $event.color,
                textcolor: $event.text_color
              })"
              />
           </StandardFlexBox>
        </template>

        <!-- Icons -->
        <template v-if="bottom_bar.content === 'icon'">
          <div class="package-editor-bottom-bar-icon">
            <TText value="ICONS" />
            <div class="d-flex align-center">
              <template v-if="selectedIsFavorite">
                <TTooltip value="remove from favorite">
                  <v-btn class="mr-2" icon @click="remove_favorite_icons(work_package.icon)">
                    <TIcon name="star-filled"/>
                  </v-btn>
                </TTooltip>
              </template>
              <template v-else>
                <TTooltip value="add to favorite">
                  <v-btn class="mr-2" icon @click="add_favorite_icons(work_package.icon)" >
                    <TIcon name="star"/>
                  </v-btn>
                </TTooltip>
              </template>
              <SearchBar
                :is_live_emit="true"
                min_height = "40"
                max_width="256"
                @search="search_term = $event;"
              />
            </div>
          </div>
          <template v-if="favorite_user_icons.length > 0">
            <StandardFlexBox >
             <WorkBenchWorkPackageIconPicker
              v-for="icon in favorite_user_icons"
              :key="icon.id"
              :icon="icon.id"
              :color="work_package.color"
              :text_color="work_package.textcolor"
              :selected_icon="getNewIcon(work_package.icon)"
              @clickIcon="genericUpdate({
                icon: $event
              })"
              />
           </StandardFlexBox>
           <v-divider></v-divider>
          </template>
          <!-- NOTE: these hardcoded values correspond to the search bar and footer respectivly -->
           <StandardFlexBox height="calc(100% - 54px - 30px)">
             <WorkBenchWorkPackageIconPicker
              v-for="icon in filtered_icons"
              :key="icon.id"
              :icon="icon.id"
              :color="work_package.color"
              :text_color="work_package.textcolor"
              :selected_icon="getNewIcon(work_package.icon)"
              @clickIcon="genericUpdate({
                icon: $event
              })"
              />
           </StandardFlexBox>
        </template>
      </div>
    </StandardFlexBox>
    </template>
  </StandardDialogFullScreen>
</template>
<script>
  // import { getWorkPackageIcons } from '../../helpers/data';
  import { WorkBenchWorkPackageMixin } from '@/mixins/WorkBenchWorkPackage.mixin.js'
  // import StandardDropdown from '@/components/StandardComponents/StandardDropdown.component.vue'
  import { mapGetters,mapActions } from 'vuex';
  import SearchBar from '@/components/WorkPackageWIP/SearchBar.component.vue';
  import RadialCheckbox from '@/components/WorkPackageWIP/RadialCheckbox.component.vue'
  import TIcon from '@/components/Taktify/TIcon.component.vue'

  export default {
    components: {
      SearchBar,
      RadialCheckbox,
      TIcon
    },

    props: [
      'work_package_id',
      'create',
      'create_sequence',
      'nav_back',
      'location',
      'sequence_id',
      'waggon_id',
      'read_only',
      'create_for_project',
      'creation_params',
    ],

    data: () => ({
      search_term: '',
      save_to_workbench: true,
      favorite_user_icons: [],
      favorite_user_colors: [],
    }),

    created(){
      this.request_favorite_icons()
      this.request_favorite_colors()
      // hacky way to fix it, I don't know why read_only is not set correctly
      if (this.location === 'TaktPlanBacklogWorkPackageCopy') {
        this.read_only = false;
        this.nav_back = 'TaktPlanBacklogWorkPackageInfo';
      }

      // if (this.work_package){
      //   let self = this;
      //   this.$store.dispatch('WorkBench/createWBObject', {
      //     url: [
      //       {ai: 'workpackagerecommendations'},
      //     ],
      //     wb_object: this.create?
      //     {
      //       id: -1,
      //       color: 'red lighten-1',
      //       token: '',
      //       icon: 'obj-drainage-pipe',
      //     }
      //     :
      //     {
      //       id: parseInt(this.work_package_id),
      //       color: this.work_package.color,
      //       token: this.work_package.token,
      //       icon: this.work_package.icon,
      //     }
      //   }).then(() => {
      //     self.ai_animation = false;
      //   });
      // }
    },

    computed: {
      ...mapGetters('Auth', [
        'getUser',
        'hasPermission'
      ]),    
      ...mapGetters('Ultra', [
        'getUObject',
        'getUObjects',
    ]),
      step_types(){
        return [
          `${this.prefix_one_step}${this.prefix_two_step}logisticsteps`,
          `${this.prefix_one_step}${this.prefix_two_step}designsteps`,
          `${this.prefix_one_step}${this.prefix_two_step}worksteps`,
          `${this.prefix_one_step}${this.prefix_two_step}qualitysteps`,
          `${this.prefix_one_step}${this.prefix_two_step}defectsteps`,
          `${this.prefix_one_step}${this.prefix_two_step}handoversteps`,
          `${this.prefix_one_step}${this.prefix_two_step}materialsteps`,
          `${this.prefix_one_step}${this.prefix_two_step}machinesteps`
      ]},
      selectedIsFavorite(){
        let is_favorite = false
        this.favorite_user_icons.forEach(user_icon => {
          if(user_icon.id === this.work_package.icon){
            is_favorite = true
          }
        })
        return is_favorite
      },
      selectedColorIsFavorite(){
        let is_favorite = false
        this.favorite_user_colors.forEach(user_color => {
          if(user_color.color === this.work_package.color){
            is_favorite = true
          }
        })
        return is_favorite
      },
      filtered_icons() {
        let terms = this.search_term.split(' ');
        let ret = this.$store.state.Ultra.icons;
        terms.forEach(term => {
          // check if id contains search terms or any hashtag
          // gets faster for each consecutive term assuming ret gets smaller
          ret = ret.filter(element => element.id.includes(term) || element.hashtags.filter(hashtag => hashtag.includes(term)).length != 0)
        });
        return ret;
      },
    },

    methods: {
      ...mapActions('Ultra', [
      'createUObject',
      'updateUObject',
      'deleteUObject',
      'requestUObject'
    ]),
    ...mapActions('SnackBar', [
      'requestSnackbarCreate'
    ]),
      request_favorite_icons() {   
        this.requestUObject({
          url: [
            { users: this.getUser.id },
            { usericons: '' },
            { showWithEntitiesNormalized: ''}
          ], 
          no_cache: true,
        }).then(() => {
          this.favorite_user_icons = this.read_favorite_icons()
        })
      }, 
      add_favorite_icons(oldIcon){
        let icon = this.getNewIcon(oldIcon)
        let duplicate = false
        this.favorite_user_icons.forEach(user_icon => {
          if(user_icon.id === icon){
            duplicate = true
          }
        })
        if(duplicate){
          return
        }
        this.createUObject({
          url: [
            { users: this.getUser.id },
            { usericons: '' },
            { showWithEntitiesNormalized: ''}
          ],
          u_object: {
            icon: icon
          },
          call_only : true,
          add_u_object: true
        }).then(() => {
          this.request_favorite_icons()
        })
      },
      remove_favorite_icons(oldIcon){
        let icon = this.getNewIcon(oldIcon)
        let is_favorite = false
        let target_icon
        this.favorite_user_icons.forEach(user_icon => {
          if(user_icon.id === icon){
            is_favorite = true
            target_icon = user_icon.obj_id
          }
        })
        if(!is_favorite){
          return
        }
        this.deleteUObject({
          url: [
            { users: this.getUser.id },
            { usericons: target_icon},
          ],
          call_only : true,
        }).then(() => {
          this.favorite_user_icons = this.read_favorite_icons()
        });
      },
      read_favorite_icons(){
        let icons = this.getUObjects({type: 'usericons'})
        let readable_icons = []
        icons.forEach(icon => {
          readable_icons.push({id: icon.icon, obj_id: icon.id})
        })
        return readable_icons
      },
      request_favorite_colors() {
        this.requestUObject({
          url: [
            { users: this.getUser.id },
            { usercolors: '' },
            { showWithEntitiesNormalized: ''}
          ],
          no_cache: true,
        }).then(() => {
          this.favorite_user_colors = this.read_favorite_colors()
        })
      },
      add_favorite_colors(color){
        let duplicate = false
        this.favorite_user_colors.forEach(user_color => {
          if(user_color.color === color){
            duplicate = true
          }
        })
        if(duplicate){
          return
        }
        this.createUObject({
          url: [
            { users: this.getUser.id },
            { usercolors: '' },
            { showWithEntitiesNormalized: ''}
          ],
          u_object: {
            color: color
          },
          call_only : true,
          add_u_object: true
        }).then(() => {
          this.request_favorite_colors()
        })
      },
      remove_favorite_colors(color){
        let is_favorite = false
        let target_color
        this.favorite_user_colors.forEach(user_color => {
          if(user_color.color === color){
            is_favorite = true
            target_color = user_color.obj_id
          }
        })
        if(!is_favorite){
          return
        }
        this.deleteUObject({
          url: [
            { users: this.getUser.id },
            { usercolors: target_color},
          ],
          call_only : true,
        }).then(() => {
          this.favorite_user_colors = this.read_favorite_colors()
        });
      },
      read_favorite_colors(){
        let colors = this.getUObjects({type: 'usercolors'})
        let readable_colors = []
        colors.forEach(color => {
          readable_colors.push({color: color.color, obj_id: color.id})
        })
        return readable_colors
      },

      createWP(){
        console.log("hier", this.$route.params, this.create_for_project, this.save_to_workbench, this.$route.params.wfolder)
        if (this.create_for_project) {
          let ultra_url;
          let self = this;

          if(this.creation_params.type === 'wbworkpackages') {
            ultra_url = [
              { projects: this.creation_params.route_params.project_id },
              { wbgroups: this.creation_params.route_params.wbgroup_id },
              { wblines: this.creation_params.route_params.wbline_id },
              { wbworkpackages: '' },
              { showWithEntitiesNormalized: ''}
            ]
            if (this.$store.state.ProjectBacklog.new_wp_position !== false) {
              this.work_package.position = this.$store.state.ProjectBacklog.new_wp_position;
            }
            this.createUObject({
              url: ultra_url,
              u_object: this.work_package,
            }).then(() =>  {
              if (!this.save_to_workbench) {
                self.$router.push({
                  name: self.nav_back?self.nav_back:'WorkBenchWorkPackages'
                });
              }
            });
          }

          if(this.creation_params.type === 'tworkpackages') {
            ultra_url = [
              { projects: this.creation_params.route_params.project_id },
              { trains: this.creation_params.route_params.train_id },
              { taktareas: this.creation_params.route_params.taktarea_id },
              { twaggons: this.creation_params.route_params.twaggon_id },
              { tworkpackages: '' },
              { showWithEntitiesNormalized: ''}
            ];
              this.requestSnackbarCreate({
              url: ultra_url,
              u_object: this.work_package,
              selector: 'parent'
            }).then((payload) => {
                this.createUObject(payload).then(() =>  {
                if (!this.save_to_workbench) {
                  self.$router.push({
                    name: self.nav_back?self.nav_back:'WorkBenchWorkPackages'
                  });
                }
              });
            })
          }

          if (!this.save_to_workbench) {
            return;
          }
        }

        let url = []
          url = [
            {workpackages: 'completeworkpackage'},
            {showWithEntitiesNormalized: ''}
          ];
        this.work_package['wfolder'] = this.$route.params.wfolder
        this.createWBObject({
          url: url,
          wb_object: this.work_package,
        }).then((id) => {
          this.uploadWorkpackageImageBulk(id)
        })
      },
      genericUpdate(update){
        if (this.create || this.create_sequence) {
          let path = [
            {workpackage: ''},
          ];
          if (this.create_sequence) {
            path = [
              {sequence: ''},
              {swaggons: this.waggon_id},
              {sworkpackages: this.work_package_id},
            ];
          }
          if (this.prefix_two_wp === 'wag') {
            path = [
              {waggon: ''},
              {wagworkpackages: this.work_package_id},
            ];
          }
          this.updateWBLObject({
            path: path,
            update: update,
          });
        } else {
          let url = [
            {[`${this.prefix}workpackages`]: this.work_package_id},
          ];
          if (this.sequence_id) {
            url = [
              {[`${this.prefix}sequences`]: this.sequence_id},
              {[`${this.prefix}swaggons`]: this.waggon_id},
              {[`${this.prefix}sworkpackages`]: this.work_package_id}
            ];
          }
          if (this.prefix_two_wp === 'wag') {
            url = [
              {[`${this.prefix}waggons`]: this.waggon_id},
              {[`${this.prefix}wagworkpackages`]: this.work_package_id},
            ];
          }
          this.updateWBObject({
            url: url,
            update: update
          });
        }
      },
      genericUpdateStep(selected_step_type, index, update, step){
        if (!this.edit_step_templates) {
          if (this.create || this.create_sequence) {
            let path = [];
            if (this.create_sequence) {
              path = [
                {sequence: ''},
                {swaggons: this.waggon_id},
                {sworkpackages: this.work_package_id},
                {[selected_step_type]: index}
              ];
            } else {
              path = [
                {workpackage: ''},
                {[selected_step_type]: index}
              ];
            }
            if (this.prefix_two_wp === 'wag') {
              path = [
                {waggon: ''},
                {wagworkpackages: this.work_package_id},
                {[selected_step_type]: index}
              ];
            }
            this.updateWBLObject({
              path: path,
              update: update
            });
          } else {
            let url = [];
            if ( this.sequence_id ) {
              url = [
                {[`${this.prefix}sequences`]: this.sequence_id},
                {[`${this.prefix}swaggons`]: this.waggon_id},
                {[`${this.prefix}sworkpackages`]: this.work_package_id},
                {[selected_step_type]: step.id}
              ];
            } else {
              url = [
                {[`${this.prefix}workpackages`]: this.work_package_id},
                {[selected_step_type]: step.id}
              ];
            }
            if (this.prefix_two_wp === 'wag') {
              url = [
                {[`${this.prefix}waggons`]: this.waggon_id},
                {[`${this.prefix}wagworkpackages`]: this.work_package_id},
                {[selected_step_type]: step.id}
              ];
            }
            this.updateWBObject({
              url: url,
              update: update
            });
            if ( this.getWBObjectsFiltered({type: selected_step_type.substring(`${this.prefix}${this.prefix_two_wp}`.length), filter: {text: update.text}}).length === 0 ) {
              this.createWBObject({
                url: [
                  {[selected_step_type.substring(`${this.prefix}${this.prefix_two_step}`.length)]: ''},
                  {showWithEntitiesNormalized: ''}
                ],
                wb_object: update,
              })
            }
            this.step_text = '',
            this.edit_step = false
          }
        }
      },
      genericCreateStep(selected_step_type, evt){
        if (!this.edit_step_templates) {
          if (this.create || this.create_sequence) {
            let path = [];
            let obj = evt;

            if (this.create_sequence) {
              path = [
                {sequence: ''},
                {swaggons: this.waggon_id},
                {sworkpackages: this.work_package_id},
                {[selected_step_type]: ''}
              ];
            } else {
              path = [
                {workpackage: ''},
                {[selected_step_type]: ''}
              ];
            }
            if (this.prefix_two_wp === 'wag') {
              path = [
                {waggon: ''},
                {wagworkpackages: this.work_package_id},
                {[selected_step_type]: ''}
              ];
            }

            if ( selected_step_type.includes('worksteps') ) {
              obj = { text: evt.text, performance_value: 0., mass_relation: 'absolute' };
            } else if ( selected_step_type.includes('materialsteps') ) {
              obj = { text: evt.text, performance_value: 0., mass_relation: 'absolute' };
            } else if ( selected_step_type.includes('machinesteps') ) {
              obj = { text: evt.text, booking_value: 0, booking_unit: 'hours', type: 'other' };
            }

            this.createWBLObject({
              path: path,
              wbl_object: obj
            })
          } else {
            let url = [];
            if ( this.sequence_id ) {
              url = [
                {[`${this.prefix}sequences`]: this.sequence_id},
                {[`${this.prefix}swaggons`]: this.waggon_id},
                {[`${this.prefix}sworkpackages`]: this.work_package_id},
                {[selected_step_type]: ''},
                {showWithEntitiesNormalized: ''}
              ];
            } else {
              url = [
                {[`${this.prefix}workpackages`]: this.work_package_id},
                {[selected_step_type]: ''},
                {showWithEntitiesNormalized: ''}
              ];
            }
            if (this.prefix_two_wp === 'wag') {
              url = [
                {[`${this.prefix}waggons`]: this.waggon_id},
                {[`${this.prefix}wagworkpackages`]: this.work_package_id},
                {[selected_step_type]: ''},
                {showWithEntitiesNormalized: ''}
              ];
            }
            this.createWBObject({
              url: url,
              wb_object: evt,
            });
          }
          if (this.getWBObjectsFiltered({type: selected_step_type.substring(`${this.prefix}${this.prefix_two_step}`.length), filter: {text: evt.text}}).length === 0) {
            this.createWBObject({
              url: [
                {[selected_step_type.substring(`${this.prefix}${this.prefix_two_step}`.length)]: ''},
                {showWithEntitiesNormalized: ''}
              ],
              wb_object: evt,
            });
          }
          this.step_text = ''; // TODO: useless? required?
          this.update_key_add_step++;
          this.stepFlexBoxScrollBottom();
        }
      },
      genericDeleteStep(selected_step_type, index, step){
        this.edit_step = false;

        if (this.create || this.create_sequence) {
          let path = [];

          if (this.create_sequence) {
            path = [
              {sequence: ''},
              {swaggons: this.waggon_id},
              {sworkpackages: this.work_package_id},
              {[selected_step_type]: ''}
            ];
          } else {
            path = [
              {workpackage: ''},
              {[selected_step_type]: ''}
            ];
          }

          if (this.prefix_two_wp === 'wag') {
            path = [
              {waggon: ''},
              {wagworkpackages: this.work_package_id},
              {[selected_step_type]: ''}
            ];
          }

          this.deleteWBLObject({
            path: path,
            index: index
          });
        } else {
          let url = [];

          if ( this.sequence_id ) {
            url = [
              {[`${this.prefix}sequences`]: this.sequence_id},
              {[`${this.prefix}swaggons`]: this.waggon_id},
              {[`${this.prefix}sworkpackages`]: this.work_package_id},
              {[selected_step_type]: step.id}
            ];
          } else {
            url = [
              {[`${this.prefix}workpackages`]: this.work_package_id},
              {[selected_step_type]: step.id}
            ];
          }

          if (this.prefix_two_wp === 'wag') {
            url = [
              {[`${this.prefix}waggons`]: this.waggon_id},
              {[`${this.prefix}wagworkpackages`]: this.work_package_id},
              {[selected_step_type]: step.id}
            ];
          }
          this.deleteWBObject({
            url: url
          });
        }
      },
      checkStepPermission(type){
        let actual_type = type.substring(`${this.prefix_one_step}${this.prefix_two_step}`.length, type.length-5);
        let permission_name = `${this.prefix_one_step.toUpperCase()}${this.prefix_two_step.toUpperCase()}${actual_type.charAt(0).toUpperCase()}${actual_type.slice(1)}Step READ`;
        let permission = this.hasPermission(permission_name);
        return permission;
      },
      switchStepTab(type){
        if (this.checkStepPermission(type)) {
          this.bottom_bar.content = type;
          this.selected_step_type = type;
          if (this.bottom_bar.show){
            this.add_step = true;
          }
        }
      },
      uploadImage(){

        if (this.create || this.create_sequence) {
          this.new_image.id = this.new_image_id;
          this.new_image.created = '';
          this.new_image.image = this.new_image.local_url;

          let path = [];

          if (this.create_sequence) {
            path = [
              {sequence: ''},
              {swaggons: this.waggon_id},
              {sworkpackages: this.work_package_id},
              {[`${this.prefix}${this.prefix_two_wp !== 'w'?this.prefix_two_wp:''}workpackageimages`]: ''}
            ];
          } else {
            path = [
              {workpackage: ''},
              {[`${this.prefix}${this.prefix_two_wp !== 'w'?this.prefix_two_wp:''}workpackageimages`]: ''}
            ];
          }

          if (this.prefix_two_wp === 'wag') {
            path = [
              {waggon: ''},
              {wagworkpackages: this.work_package_id},
              {[`${this.prefix}${this.prefix_two_wp !== 'w'?this.prefix_two_wp:''}workpackageimages`]: ''}
            ];
          }

          this.createWBLObject({
            path: path,
            wbl_object: this.new_image
          });

          this.new_image = {
            file: false,
            local_url: false,
            name: false,
            comment: ''
          };

          this.new_image_id++;

        } else {
          this.uploadWorkpackageImage();
          this.update_key_add_image++;
        }
      },
      handleRecommendationsClick(selected_step_type, step_text){

      // If it's create
      if(this.create || this.create_sequence){
        let path = [];
        if (this.create_sequence) {
          path = [
            {sequence: ''},
            {swaggons: this.waggon_id},
            {sworkpackages: this.work_package_id},
            {[selected_step_type]: ''}
          ];
        } else {
          path = [
            {workpackage: ''},
            {[selected_step_type]: ''}
          ];
        }
        
        let wbl_object = {};
        if(selected_step_type.includes('work')){
            wbl_object = {
              text: step_text,
              done: false,
            }
        } else if(selected_step_type.includes('material')){
            wbl_object = {
              text: step_text,
              conversion_factor: 1,
              conversion_unit: 'absolute',
              done: false,
            }
        } else {
            wbl_object = {
              text: step_text,
              done: false,
            }
        }

        this.createWBLObject({
          path: path,
          wbl_object: wbl_object
        })
      } else {
      // If it's not create
        let url = [];
        if ( this.sequence_id ) {
          url = [
            {[`${this.prefix}sequences`]: this.sequence_id},
            {[`${this.prefix}swaggons`]: this.waggon_id},
            {[`${this.prefix}sworkpackages`]: this.work_package_id},
            {[selected_step_type]: ''},
            {showWithEntitiesNormalized: ''}
          ];
        } else {
          url = [
            {[`${this.prefix}workpackages`]: this.work_package_id},
            {[selected_step_type]: ''},
            {showWithEntitiesNormalized: ''}
          ];
        }

        this.createWBObject({
          url: url,
          wb_object: {
            text: step_text,
            done: false,
          },
        });
      }

      if(this.getWBObjectsFiltered({type: selected_step_type.substring(`${this.prefix}${this.prefix_two_wp}`.length), filter: {text: step_text}}).length === 0){
        this.createWBObject({
          url: [
            {[selected_step_type.substring(`${this.prefix}${this.prefix_two_step}`.length)]: ''},
            {showWithEntitiesNormalized: ''}
          ],
          wb_object: {
            text: step_text,
            }
        })
      }

      this.step_text = '';
      this.update_key_add_step++;
      this.stepFlexBoxScrollBottom();
      }
    },
    // components: {
    //   StandardDropdown
    // },
    mixins: [
      WorkBenchWorkPackageMixin,
    ],
  }
</script>

<style>
  .package-editor-bottom-bar-icon {
    height: 54px;
    padding-bottom: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 16px; flex-grow: 1;
  }
  .no-uppercase {
     text-transform: unset !important;
  }
</style>
